import styled from "@emotion/styled";

export const ContainerNavegacaoHeader = styled.div`
  padding: ${(props) => (props.headerFixo ? `8px 0px 8px 50px` : `25px 40px 25px 40px;`)};
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom-left-radius: 16px;
  ${(props) => props.headerFixo && `border-top: solid 1px ${props.theme.cores.surface6};`}
  width: 100%;
  //position: static;
  //position: absolute
  border-bottom-right-radius: 16px;
  ${(props) => props.headerFixo && `border-top: solid 1px ${props.theme.cores.surface6};`}
  ${(props) => props.headerFixo && `position: fixed;`}
  ${(props) => props.headerFixo && `top: 60px;`}
  ${(props) => props.headerFixo && `left: 0px;`}
  //${(props) => (props.headerFixo ? `width: 97.4%;` : `width: 100%;`)};
  
  ${(props) => props.headerFixo && `padding-right: 60px;`}
  ${(props) => props.headerFixo && `background-color: ${props.theme.cores.surfaceBackground1};`}  
  ${(props) => props.headerFixo && `z-index: 5;`}  
  ${(props) => props.headerFixo && `margin-bottom: 50px`}  
  ${(props) => props.headerFixo && `box-shadow: 0px 15px 26px 0px rgba(0,0,0,0.2);;`}  
  transform-origin: top;
  ${(props) => props.headerFixo && `animation: expandirMenu 0.2s ease`};
  ${(props) =>
    props.headerFixo &&
    `  
    box-shadow: 3px 6px 10px 0px rgba(0,0,0,0.75);
    -webkit-box-shadow: 3px 6px 10px 0px rgba(0,0,0,0.75);
    -moz-box-shadow: 3px 6px 10px 0px rgba(0,0,0,0.75);
  `};

  .itemFixado {
    content: "teste";
  }

  ${(props) =>
    props.headerFixo
      ? `
      .itemFixado{
        content: '1'
      };
  `
      : `
  .itemFixado{
        content: ''
      };
   `}

  @keyframes expandirMenu {
    0% {
      transform: scaleY(0);
    }
    100% {
      transform: scaleY(1);
    }
  }

  @media (min-height: 867px) {
    ${(props) => props.headerFixo && `inset: 60px 0px 86% 0%;`}
  }

  @media (max-width: 768px) {
    flex-direction: column;
    justify-content: center;
    padding: 0px 10px 25px 10px;
    button {
      width: 50%;
      font-size: 16px;
    }
  }
`;

export const TituloNavegacaoHeader = styled.p`
  font-size: ${(props) => (props.headerFixo ? `22px` : `30px`)};
  font-weight: 400;
  font-family: "Comfortaa", cursive;
  color: ${({ theme }) => theme.cores.textoSimples};

  @media (max-width: 768px) {
    margin-bottom: 20px;
    align-self: center;
    justify-self: center;
    font-size: 24px;
    padding: 10px;
    text-align: center;
  }
`;

export const Divisor = styled.div`
  ${(props) => props.headerFixo && `margin-top: 55px;`}
  background-color: ${({ theme }) => theme.cores.textoSimples};
  height: 0.5px;
  width: 100%;
  opacity: 0.2;
`;

export const BreadcrumbCustom = styled.div`
  margin-right: 25px;
  font-size: 16px;
  p {
    display: none;
  }
`;

export const IconeCustom = styled.div`
  svg {
    font-size: 18px !important;
  }
`;

export const DivBotoes = styled.div`
  @media (max-width: 360px) {
    display: flex;
    flex-direction: column !important;
    button {
      width: 100% !important;
    }
  }
`;
